<template>
  <section>
    <md-button
      class="md-primary md-raised"
      v-if="!timeReserved"
      :disabled="!isReserveButtonEnabled"
      @click="reserve"
      >Reserve{{ selectedTime == null ? "" : " at " + selectedTime }}</md-button
    >
    <md-button
      class="md-primary md-raised"
      v-if="timeReserved && showBookNowButton"
      :disabled="isBookNowDisabled"
      @click="book"
      >Book now</md-button
    >
  </section>
</template>

<script>
import { eventBus } from "../eventbus";
import firebase from "../../../firebaseConfig";

const db = firebase.firestore();

export default {
  name: "BookingDialogActions",
  data: function () {
    return {
      timeReserved: false,
      clientDetails: {},

      selectedTreatment: this.$store.state.user.selectedTreatment,
      showBookNowButton: true,
      hasBooked: false,
      showContactForm: false,
      hasContactDetails: false,
    };
  },
  methods: {
    book: function () {
      this.hasBooked = true;
      this.showContactForm = false;
      this.showBookNowButton = false;

      this.addAppointment();

      eventBus.bookNow();
    },

    reserve: function () {
      this.timeReserved = true;

      // go to last step, fill in contact details
      this.$router.push("/contact-details");

      eventBus.reserveDate();
    },
    addAppointment: function () {
      var self = this;
      //this.savingInProgress = true;

      let user = firebase.auth().currentUser;
      let website = window.location.hostname;

      if (user != null) {
        user.getIdTokenResult().then((idTokenResult) => {
          // Confirm the user is part of business.
          let customer = idTokenResult.claims.customer;
          return self.saveAppointment(website, customer, user.uid);
        });
      } else {
        return self.saveAppointment(website, null, null);
      }
    },
    saveAppointment: function (website, customer, createdBy) {
      var self = this;

      return db
        .collection("appointments")
        .add({
          client: this.clientDetails.clientName,
          email: this.clientDetails.clientEmail,
          tel: this.clientDetails.clientTel,
          date: this.selectedDate,
          time: this.selectedTime,
          treatment: {
            name: this.selectedTreatment.name,
            price: this.selectedTreatment.price,
          },
          creationStarted: this.clientDetails.creationStartedAt,
          creationEnded: new Date(),
          customerId: customer,
          createdBy: createdBy,
          website: website,
          menuId: self.$store.state.menuId,
          isConfirmed: false,
        })
        .then((data) => {
          console.log("Document successfully written!", data.id);
          self.appointmentId = data.id;
          //self.savingInProgress = false;
          eventBus.newAppointmentCreated(data.id);
        })
        .catch((error) => {
          self.savingInProgress = false;
          console.error("Error writing document: ", error);
        });
    },
  },
  computed: {
    selectedTime() {
      return this.$store.state.user.selectedTime;
    },
    selectedDate() {
      return this.$store.state.user.selectedDate;
    },
    isBookNowDisabled() {
      return !this.hasContactDetails;
    },
    isReserveButtonEnabled() {
      return this.selectedTime != null && this.selectedDate != null;
    },
  },
  created: function () {
    var self = this;
    eventBus.$on("selected-date-time", function (date, localTime) {
      console.log("event handler, selected-date-time:", date, localTime);

      if (localTime == null) self.timeReserved = false;
    });

    eventBus.$on("contact-details-valid", function (clientDetails) {
      self.hasContactDetails = true;
      self.clientDetails = clientDetails;
    });
    eventBus.$on("contact-details-invalid", function (clientDetails) {
      self.hasContactDetails = false;
      self.clientDetails = clientDetails;
    });
    eventBus.$on("selected-treatment", function (treatment) {
      self.selectedTreatment = treatment;

      // if (treatment) self.showBookNowButton = true;
    });
    eventBus.$on("selected-category", function () {
      // reset Ui
      self.showBookNowButton = true;
    });
  },
};
</script>

<style>
</style>